import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { RadioGroup } from '@restworld/ui-ds-base';
import { SkeletonLoading } from '@restworld/ui-ds-base';

import { WizardStepProps } from '../../worker-application-wizard.types';
import { useWorkerApplicationCxt } from '../../worker-application-wizard.context';

export const WizardEleventhStep: React.FunctionComponent<WizardStepProps> = () => {
  const { control } = useFormContext();
  const {
    errorsTextMap,
    fieldOptions: { workerResearchStatus },
  } = useWorkerApplicationCxt();
  const id = `research_status_key`;
  return workerResearchStatus ? (
    <div className="flex flex-col gap-4">
      <Controller
        name={id}
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <RadioGroup
            id={id}
            isFullWidth
            helperText={errorsTextMap[id]}
            options={workerResearchStatus}
            returnKey="key"
            testId="worker-search-status-options"
            {...field}
          />
        )}
      />
    </div>
  ) : (
    <SkeletonLoading variant="paragraph" />
  );
};
export default WizardEleventhStep;
